import { useEffect } from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";
import { useCurrencyManager } from "../hooks/useCurrencyManager";

const CurrencySelection = ({classElement = 'tw-text-white'}) => {
  const { currencies, selectedCurrency, loading, changeCurrency } = useCurrencyManager();

  return (
    <li className='on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white'>
        <Link to='#' className={`py-8 text-sm selected-text ${classElement}`}>
            {loading ? (<LoadingSpinner />) : selectedCurrency}
        </Link>
        <ul className='px-0 py-8 selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm'>
            {
                currencies && currencies.map(i => {
                    const isActive = i.short_name === selectedCurrency;
                    return (
                        <li key={i.short_name}>
                            <Link
                                to='#'
                                className={`gap-8 px-16 py-6 text-xs ${isActive ? 'text-main-600' : 'text-gray-500'} hover-bg-gray-100 flex-align rounded-0`}
                                onClick={() => changeCurrency(i.short_name)}
                            >
                                {i.short_name}
                            </Link>
                        </li>
                    )
                })
            }
        </ul>
    </li>
  );
};

export default CurrencySelection;